/* TerraLife — consentement aux cookies (bandeau du thème, snippets/content-bottom.liquid).
   Premier écran : tout autoriser, personnaliser, ou « Continuer sans accepter ». Le choix,
   par catégorie (préférences, statistiques, marketing), est gardé 6 mois dans le cookie
   tl_consent (« a1.m0.p1 » ; « granted » / « denied » des premières versions restent lus) et
   transmis à Shopify (Customer Privacy API), que respectent les applis : Google & YouTube
   (Google Analytics, Google Ads), Meta… Un choix déjà enregistré chez Shopify est repris.
   Tout lien vers « #cookies » rouvre le bandeau pour changer d'avis. */
(() => {
  const MAX_AGE = 60 * 60 * 24 * 182; // 6 mois
  const ALL = { analytics: true, marketing: true, preferences: true };
  const NONE = { analytics: false, marketing: false, preferences: false };

  /** The visitor's choice, or null when not made yet. */
  const read = () => {
    const m = document.cookie.match(/(?:^|;\s*)tl_consent=([^;]+)/);
    if (!m) return null;
    const v = decodeURIComponent(m[1]);
    if (v === 'granted') return { ...ALL };
    if (v === 'denied') return { ...NONE };
    const parts = /^a([01])\.m([01])\.p([01])$/.exec(v);
    return parts ? { analytics: parts[1] === '1', marketing: parts[2] === '1', preferences: parts[3] === '1' } : null;
  };

  const write = (c) => {
    const v = `a${+c.analytics}.m${+c.marketing}.p${+c.preferences}`;
    document.cookie = `tl_consent=${v}; max-age=${MAX_AGE}; path=/; SameSite=Lax`;
    // The theme's own cookie only hides its banner: keep it in step.
    document.cookie = `cookie_bar=dismiss; max-age=${MAX_AGE}; path=/; SameSite=Lax`;
  };

  /** Tells Shopify (and the pixels of the apps it manages) what the visitor chose. */
  const tellShopify = (c) => {
    const apply = () => {
      const privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (!privacy || typeof privacy.setTrackingConsent !== 'function') return;
      const yes = (b) => (b ? 'yes' : 'no');
      const current = typeof privacy.currentVisitorConsent === 'function' ? privacy.currentVisitorConsent() : null;
      if (
        current &&
        current.analytics === yes(c.analytics) &&
        current.marketing === yes(c.marketing) &&
        current.preferences === yes(c.preferences)
      ) {
        return;
      }
      privacy.setTrackingConsent(
        { analytics: c.analytics, marketing: c.marketing, preferences: c.preferences, sale_of_data: c.marketing },
        () => {}
      );
    };
    if (window.Shopify && window.Shopify.customerPrivacy) apply();
    else if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
        if (!error) apply();
      });
    }
  };

  const banner = () => document.getElementById('cookie');
  const q = (sel) => banner()?.querySelector(sel) ?? null;

  /** First screen, or the categories (pre-ticked with the current choice). */
  const show = (customize) => {
    const el = banner();
    if (!el) return;
    el.classList.remove('hidden');
    const prefs = q('[data-tl-consent-prefs]');
    const content = q('.cookie-content');
    if (prefs) prefs.hidden = !customize;
    if (content) content.hidden = customize;
    const customizeBtn = q('[data-tl-consent-customize]');
    const save = q('[data-tl-consent-save]');
    if (customizeBtn) customizeBtn.hidden = customize;
    if (save) save.hidden = !customize;
    if (customize) {
      const current = read() ?? NONE;
      el.querySelectorAll('[data-tl-cat]').forEach((box) => {
        box.checked = !!current[box.dataset.tlCat];
      });
    }
  };

  const decide = (c) => {
    write(c);
    tellShopify(c);
    banner()?.classList.add('hidden');
  };

  document.addEventListener('click', (event) => {
    const t = event.target;
    const choice = t.closest('[data-tl-consent]');
    if (choice) {
      event.preventDefault();
      decide(choice.dataset.tlConsent === 'granted' ? { ...ALL } : { ...NONE });
      return;
    }
    if (t.closest('[data-tl-consent-customize]')) {
      event.preventDefault();
      show(true);
      return;
    }
    if (t.closest('[data-tl-consent-save]')) {
      event.preventDefault();
      const c = { ...NONE };
      banner()
        ?.querySelectorAll('[data-tl-cat]')
        .forEach((box) => {
          c[box.dataset.tlCat] = box.checked;
        });
      decide(c);
      return;
    }
    if (t.closest('a[href$="#cookies"]')) {
      event.preventDefault();
      show(true);
    }
  });

  /** A choice Shopify already recorded for this visitor (its cookie lasts longer than ours). */
  const fromShopify = (done) => {
    const take = () => {
      const privacy = window.Shopify && window.Shopify.customerPrivacy;
      const v = privacy && typeof privacy.currentVisitorConsent === 'function' ? privacy.currentVisitorConsent() : null;
      if (!v || !['yes', 'no'].includes(v.analytics) || !['yes', 'no'].includes(v.marketing)) return done(null);
      done({ analytics: v.analytics === 'yes', marketing: v.marketing === 'yes', preferences: v.preferences === 'yes' });
    };
    if (window.Shopify && window.Shopify.customerPrivacy) take();
    else if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => (error ? done(null) : take()));
    } else done(null);
  };

  const choice = read();
  if (choice) tellShopify(choice);
  else
    fromShopify((known) => {
      if (known) {
        write(known);
        banner()?.classList.add('hidden');
      } else {
        // Not chosen yet (an older « dismiss » of the theme no longer counts): ask.
        show(false);
      }
    });
})();
